import React from "react";
import PropTypes from "prop-types";

const InputError = ({ visible, label }) => {
    if (visible) {
        return (<div className="inputNotificationContainer">
            <i className="inputNotificationIcon glyphicon glyphicon-exclamation-sign" />
            <div className="inputNotificationText">{label}</div>
        </div>);
    }
    return null;
};

InputError.propTypes = {
    visible: PropTypes.bool,
    label: PropTypes.string
};

export default InputError;
